export const GENRES = [
  {
    key: "corridos_nortenos",
    name: "Corridos Norteños",
    tagline: "Acordeón, bajo sexto y orgullo de rancho.",
    image: "https://images.pexels.com/photos/18146834/pexels-photo-18146834.jpeg",
    accent: "#FFB800",
    style_examples: "Tigres del Norte, Grupo Frontera, Los Tucanes de Tijuana, Cardenales de Nuevo León",
    quick_artists: [
      "Los Tigres del Norte", "Grupo Frontera", "Ramón Ayala", "Los Tucanes de Tijuana",
      "Cardenales de Nuevo León", "Intocable", "Pesado", "Jenni Rivera", "Chiquis Rivera",
    ],
  },
  {
    key: "corridos_tumbados",
    name: "Corridos Tumbados",
    tagline: "Tumbao, swag y guitarra cruda.",
    image: "https://images.pexels.com/photos/36970101/pexels-photo-36970101.jpeg",
    accent: "#B4F34A",
    style_examples: "Peso Pluma, Natanael Cano, Javy",
    quick_artists: [
      "Peso Pluma", "Natanael Cano", "Javy",
    ],
  },
  {
    key: "reggaeton",
    name: "Reggaeton",
    tagline: "Dembow, perreo y luces de neón.",
    image: "https://images.pexels.com/photos/1267317/pexels-photo-1267317.jpeg",
    accent: "#FF4B00",
    style_examples: "Bad Bunny, Daddy Yankee, J Balvin, Karol G, Anuel AA",
    quick_artists: [
      "Bad Bunny", "Daddy Yankee", "J Balvin", "Anuel AA", "Maluma", "Ozuna",
      "Karol G", "Rosalía", "Becky G", "Tini", "Natti Natasha",
    ],
  },
  {
    key: "rock",
    name: "Rock",
    tagline: "Guitarras potentes, alma rebelde.",
    image: "https://images.pexels.com/photos/167636/pexels-photo-167636.jpeg",
    accent: "#FFB800",
    style_examples: "Maná, Caifanes, Soda Stereo, Café Tacvba, Molotov",
    quick_artists: [
      "Maná", "Caifanes", "Soda Stereo", "Café Tacvba", "Molotov", "Zoé",
      "Enanitos Verdes", "Julieta Venegas", "Ely Guerra", "Andrea Echeverri",
    ],
  },
  {
    key: "balada_romantica",
    name: "Balada Romántica",
    tagline: "Para los amores que nunca se olvidan.",
    image: "https://images.unsplash.com/photo-1557241597-9e5b0a3af54c",
    accent: "#FF4B00",
    style_examples: "José José, Luis Miguel, Ricardo Montaner, Camilo Sesto, Joan Sebastian",
    quick_artists: [
      "José José", "Luis Miguel", "Ricardo Montaner", "Camilo Sesto", "Joan Sebastian",
      "Vicente Fernández", "Rocío Dúrcal", "Ana Gabriel", "Yuri", "Marisela", "Pandora",
    ],
  },
  {
    key: "salsa",
    name: "Salsa",
    tagline: "Sabor caribeño, piano y sazón.",
    image: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e",
    accent: "#FF5A1E",
    style_examples: "Marc Anthony, Gilberto Santa Rosa, Héctor Lavoe, Rubén Blades, Willie Colón",
    quick_artists: [
      "Marc Anthony", "Gilberto Santa Rosa", "Héctor Lavoe", "Rubén Blades", "Willie Colón",
      "Víctor Manuelle", "Celia Cruz", "La India", "Olga Tañón", "Yolanda Rivera",
    ],
  },
  {
    key: "cumbia",
    name: "Cumbia",
    tagline: "Cumbia mexicana: acordeón, güiro y pura fiesta.",
    image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819",
    accent: "#4BC8DC",
    style_examples: "Los Ángeles Azules, Sonora Mermelada, La Sonora Dinamita, Celso Piña",
    quick_artists: [
      "Los Ángeles Azules", "Sonora Mermelada", "La Sonora Dinamita", "Grupo Cañaveral",
      "Aniceto Molina", "Grupo Bryndis", "Selena", "Celso Piña (cumbia colombiana)",
    ],
  },
  {
    key: "electronica",
    name: "Música Electrónica",
    tagline: "Beats, drops y luces hasta el amanecer.",
    image: "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg",
    accent: "#4BC8DC",
    style_examples: "Daft Punk, David Guetta, Skrillex, Calvin Harris, Tiësto, Martin Garrix",
    quick_artists: [
      "Daft Punk", "David Guetta", "Skrillex", "Calvin Harris", "Tiësto", "Martin Garrix",
      "Avicii", "Marshmello", "Deadmau5", "Steve Aoki", "Diplo", "Zedd",
    ],
  },
  {
    key: "metal",
    name: "Metal",
    tagline: "Distorsión, doble bombo y pura rabia.",
    image: "https://images.pexels.com/photos/210922/pexels-photo-210922.jpeg",
    accent: "#FF4B00",
    style_examples: "Metallica, Iron Maiden, Black Sabbath, Slipknot, Megadeth",
    quick_artists: [
      "Metallica", "Iron Maiden", "Black Sabbath", "Slipknot", "Megadeth", "System of a Down",
      "Disturbed", "Korn", "Lamb of God", "Brujería", "Transmetal", "Anabantha",
    ],
  },
  {
    key: "himnos",
    name: "Himnos",
    tagline: "Del himno solemne al canto de cancha.",
    image: "https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg",
    accent: "#FFB800",
    style_examples: "Solemne (himno nacional), Futbolero (cumbia villera), Murga y Candombe, Ska, Trap",
    quick_artists: [
      "Solemne (tipo himno nacional)",
      "Futbolero (Cumbia Villera estilo Pibes Chorros)",
      "Murga y Candombe",
      "Ska",
      "Trap / Hip-Hop",
    ],
  },
  {
    key: "rap",
    name: "Rap",
    tagline: "Rimas crudas, flow de la calle.",
    image: "https://images.pexels.com/photos/1626481/pexels-photo-1626481.jpeg",
    accent: "#B4F34A",
    style_examples: "Santa Fe Klan, Cartel de Santa, Aczino, C-Kan, Akwid, Control Machete",
    quick_artists: [
      "Santa Fe Klan", "Cartel de Santa", "Aczino", "C-Kan", "Akwid", "Control Machete",
      "Kapanga", "Tornillo", "Dharius", "Snoop Dogg", "Eminem", "Drake", "Kendrick Lamar",
    ],
  },
  {
    key: "banda",
    name: "Música de Banda",
    tagline: "Tuba, metales y puro regional mexicano.",
    image: "https://images.pexels.com/photos/167471/pexels-photo-167471.jpeg",
    accent: "#FFB800",
    style_examples: "Banda MS, Banda Pequeño Musical, Grupo Frontera, Banda El Recodo",
    quick_artists: [
      "Banda MS", "Banda Pequeño Musical", "Grupo Frontera", "Banda El Recodo",
      "Julión Álvarez", "La Adictiva", "Calibre 50", "Banda Los Recoditos",
      "Christian Nodal", "Espinoza Paz", "Jenni Rivera",
    ],
  },
  {
    key: "mariachi",
    name: "Música de Mariachi",
    tagline: "Trompetas, violines y orgullo mexicano.",
    image: "https://images.pexels.com/photos/8639009/pexels-photo-8639009.jpeg",
    accent: "#FF4B00",
    style_examples: "Vicente Fernández, Pedro Infante, Jorge Negrete, Alejandro Fernández",
    quick_artists: [
      "Vicente Fernández", "Pedro Infante", "Jorge Negrete", "Alejandro Fernández",
      "Lucha Villa", "Aida Cuevas", "Mariachi Vargas de Tecalitlán", "Pepe Aguilar",
      "Antonio Aguilar", "Lola Beltrán", "Lucero", "Ana Gabriel",
    ],
  },
  {
    key: "bachata",
    name: "Bachata",
    tagline: "Guitarra romántica, ritmo dominicano y desamor.",
    image: "https://images.pexels.com/photos/1644888/pexels-photo-1644888.jpeg",
    accent: "#B4F34A",
    style_examples: "Romeo Santos, Aventura, Prince Royce, Anthony Santos",
    quick_artists: [
      "Romeo Santos", "Aventura", "Prince Royce", "Anthony Santos",
      "Juan Luis Guerra", "Frank Reyes", "Joe Veras", "Raulín Rodríguez",
      "Karol G", "Marc Anthony", "Alex Bueno",
    ],
  },
  {
    key: "instrumental",
    name: "Música Instrumental",
    tagline: "Sin voz, solo emoción y melodía pura.",
    image: "https://images.pexels.com/photos/164821/pexels-photo-164821.jpeg",
    accent: "#FFB800",
    style_examples: "Piano cinemático, Guitarra clásica, Orquestal épico, Lo-Fi chill, Jazz instrumental",
    quick_artists: [
      "Piano cinemático", "Guitarra acústica", "Orquestal épico", "Lo-Fi chill",
      "Jazz instrumental", "Ambient relajante", "Beats hip-hop", "Sintetizadores synthwave",
    ],
  },
  {
    key: "pop",
    name: "Pop",
    tagline: "Melodías pegajosas, comerciales y modernas.",
    image: "https://images.pexels.com/photos/164938/pexels-photo-164938.jpeg",
    accent: "#FFB800",
    style_examples: "Shakira, Taylor Swift, Dua Lipa, Karol G, Bruno Mars, Ariana Grande",
    quick_artists: [
      "Shakira", "Taylor Swift", "Dua Lipa", "Karol G",
      "Bruno Mars", "Ariana Grande", "Camila Cabello", "Justin Bieber",
    ],
  },
  {
    key: "ska",
    name: "Ska",
    tagline: "Vientos, ritmo brincador y energía contagiosa.",
    image: "https://images.pexels.com/photos/2747448/pexels-photo-2747448.jpeg",
    accent: "#B4F34A",
    style_examples: "Panteón Rococó, Maldita Vecindad, Inspector, Ska-P, Los Calzones",
    quick_artists: [
      "Panteón Rococó", "Maldita Vecindad", "Inspector", "Tijuana No!",
      "Ska-P", "Los Calzones", "La Tremenda Korte", "Los Estrambóticos",
    ],
  },
  {
    key: "trap",
    name: "Trap",
    tagline: "Bajos pesados, hi-hats rápidos y flow urbano.",
    image: "https://images.pexels.com/photos/2531728/pexels-photo-2531728.jpeg",
    accent: "#FF4B00",
    style_examples: "Bad Bunny, Anuel AA, Bzrp, Duki, Eladio Carrión, Ovi",
    quick_artists: [
      "Bad Bunny", "Anuel AA", "Bzrp", "Duki",
      "Eladio Carrión", "Ovi", "Rauw Alejandro", "Quavo", "Lil Baby",
    ],
  },
  {
    key: "hip_hop",
    name: "Hip Hop",
    tagline: "Old school, líricas profundas y boom bap.",
    image: "https://images.pexels.com/photos/9072237/pexels-photo-9072237.jpeg",
    accent: "#FFB800",
    style_examples: "Kendrick Lamar, J. Cole, Eminem, Nas, Tupac, Drake",
    quick_artists: [
      "Kendrick Lamar", "J. Cole", "Eminem", "Nas",
      "Tupac", "Drake", "Kanye West", "Jay-Z", "Akapellah",
    ],
  },
  {
    key: "country",
    name: "Country",
    tagline: "Guitarras acústicas, banjos y caminos abiertos.",
    image: "https://images.pexels.com/photos/164729/pexels-photo-164729.jpeg",
    accent: "#FFB800",
    style_examples: "Johnny Cash, Dolly Parton, Garth Brooks, Luke Combs, Tim McGraw",
    quick_artists: [
      "Johnny Cash", "Dolly Parton", "Garth Brooks", "Luke Combs",
      "Tim McGraw", "Willie Nelson", "Carrie Underwood", "Brad Paisley",
    ],
  },
  {
    key: "reggae",
    name: "Reggae",
    tagline: "Ritmo jamaiquino, conciencia y buenas vibras.",
    image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg",
    accent: "#B4F34A",
    style_examples: "Bob Marley, Damian Marley, Cultura Profética, Gondwana, Los Cafres",
    quick_artists: [
      "Bob Marley", "Damian Marley", "Cultura Profética", "Gondwana",
      "Los Cafres", "Dread Mar I", "Nonpalidece", "Zona Ganjah",
    ],
  },
  {
    key: "new_age",
    name: "New Age",
    tagline: "Sonidos atmosféricos, relajantes y meditativos.",
    image: "https://images.pexels.com/photos/3601094/pexels-photo-3601094.jpeg",
    accent: "#FFB800",
    style_examples: "Enya, Yanni, Kitaro, Vangelis, Deuter, Karunesh",
    quick_artists: [
      "Enya", "Yanni", "Kitaro", "Vangelis",
      "Deuter", "Karunesh", "Brian Eno", "Loreena McKennitt",
    ],
  },
];
